/** Removes emoji codepoints (Unicode Extended_Pictographic). Matches server-side validation. */
const EMOJI_REGEX = /\p{Extended_Pictographic}/gu;

export function stripEmojis(text: string): string {
  return text.replace(EMOJI_REGEX, '');
}
